import { __module as m } from "./index.es22.js";
import { P as u } from "./index.es23.js";
import { d as s } from "./index.es24.js";
import { T as p } from "./index.es25.js";
import { d as f } from "./index.es26.js";
import { __require as _ } from "./index.es27.js";
import { __require as c } from "./index.es28.js";
import { __require as H } from "./index.es29.js";
import { __require as q } from "./index.es30.js";
import { __require as g } from "./index.es31.js";
import { __require as x } from "./index.es32.js";
var d;
function E() {
  return d ? m.exports : (d = 1, function(a) {
    var o = u, i = s;
    function t(r, e) {
      return delete a.exports[r], a.exports[r] = e, e;
    }
    a.exports = {
      Parser: o,
      Tokenizer: p,
      ElementType: f,
      DomHandler: i,
      get FeedHandler() {
        return t("FeedHandler", _());
      },
      get Stream() {
        return t("Stream", c());
      },
      get WritableStream() {
        return t("WritableStream", H());
      },
      get ProxyHandler() {
        return t("ProxyHandler", q());
      },
      get DomUtils() {
        return t("DomUtils", g());
      },
      get CollectingHandler() {
        return t(
          "CollectingHandler",
          x()
        );
      },
      // For legacy support
      DefaultHandler: i,
      get RssHandler() {
        return t("RssHandler", this.FeedHandler);
      },
      //helper methods
      parseDOM: function(r, e) {
        var n = new i(e);
        return new o(n, e).end(r), n.dom;
      },
      parseFeed: function(r, e) {
        var n = new a.exports.FeedHandler(e);
        return new o(n, e).end(r), n.dom;
      },
      createDomStream: function(r, e, n) {
        var l = new i(r, e, n);
        return new o(l, e);
      },
      // List of all events that the parser emits
      EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
      }
    };
  }(m), m.exports);
}
export {
  E as __require
};
//# sourceMappingURL=index.es21.js.map
